import { KTIcon } from '@/_metronic/helpers/components/KTIcon'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useFilterReportRushHour } from '../../core/FilterReportRushHourProvider'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { initialFilter } from '../../core/_models'

const ReportRushHourListToolbar = () => {
  const {handleShowModal} = useFilterReportRushHour()

  const {updateFilterReportRushHourFormValue, filterReportRushHourFormValue} =
    useFilterReportRushHour()
  const {updateState, state} = useQueryRequest()
  const [filterValue, setFilterValue] = useState(initialFilter)
  const currentDate = new Date()

  const filterData = () => {
    state.set_brand_id = state.brand_id && state.brand_id.length > 0
    state.set_sub_brand_id = state.sub_brand_id && state.sub_brand_id.length > 0
    state.set_region_id = state.region_id && state.region_id.length > 0
    state.set_city_id = state.city_id && state.city_id.length > 0
    state.set_area = state.area && state.area.length > 0
    state.set_outlet_id = state.outlet_id && state.outlet_id.length > 0

    updateState(state)
    updateFilterReportRushHourFormValue({
      ...filterReportRushHourFormValue,
      brand: filterReportRushHourFormValue?.brand?.filter((brand) =>
        Boolean(state?.brand_id?.find((item) => item === brand.value))
      ),
      sub_brand: filterReportRushHourFormValue?.sub_brand?.filter((sub_brand) =>
        Boolean(state?.sub_brand_id?.find((item) => item === sub_brand.value))
      ),
      outlet: filterReportRushHourFormValue?.outlet?.filter((outlet) =>
        Boolean(state?.outlet_id?.find((item) => item === outlet.value))
      ),
      area: filterReportRushHourFormValue?.area?.filter((area) =>
        Boolean(state?.area?.find((item) => item === area.value))
      ),
      region: filterReportRushHourFormValue?.region?.filter((region) =>
        Boolean(state?.region_id?.find((item) => item === region.value))
      ),
      city: filterReportRushHourFormValue?.city?.filter((city) =>
        Boolean(state?.city_id?.find((item) => item === city.value))
      ),
    })
  }

  const resetData = () => {
    setFilterValue({
      ...filterValue,
      start_date: moment().local().format('yyyy-MM-DD'),
      end_date: moment().local().format('yyyy-MM-DD'),
    })
    updateFilterReportRushHourFormValue({
      start_date: moment().local().format('yyyy-MM-DD'),
      end_date: moment().local().format('yyyy-MM-DD'),
    })
    updateState(initialFilter)
  }

  useEffect(() => {
    let areaList: string[] = []
    if (filterReportRushHourFormValue?.area) {
      filterReportRushHourFormValue.area.forEach((element) => {
        areaList.push(element.value)
      })
    }
    let outletList: string[] = []
    if (filterReportRushHourFormValue?.outlet) {
      filterReportRushHourFormValue.outlet.forEach((element) => {
        outletList.push(element.value)
      })
    }
    let brandList: string[] = []
    if (filterReportRushHourFormValue?.brand) {
      filterReportRushHourFormValue.brand.forEach((element) => {
        brandList.push(element.value)
      })
    }
    let subBrandList: string[] = []
    if (filterReportRushHourFormValue?.sub_brand) {
      filterReportRushHourFormValue.sub_brand.forEach((element) => {
        subBrandList.push(element.value)
      })
    }
    let regionList: string[] = []
    if (filterReportRushHourFormValue?.region) {
      filterReportRushHourFormValue.region.forEach((element) => {
        regionList.push(element.value)
      })
    }
    let cityList: string[] = []
    if (filterReportRushHourFormValue?.city) {
      filterReportRushHourFormValue.city.forEach((element) => {
        cityList.push(element.value)
      })
    }

    setFilterValue({
      ...filterValue,
      set_area: Boolean(filterReportRushHourFormValue?.area),
      area: areaList,
      set_outlet_id: Boolean(filterReportRushHourFormValue?.outlet),
      outlet_id: outletList,
      set_brand_id: Boolean(filterReportRushHourFormValue?.brand),
      brand_id: brandList,
      set_sub_brand_id: Boolean(filterReportRushHourFormValue?.sub_brand),
      sub_brand_id: subBrandList,
      set_region_id: Boolean(filterReportRushHourFormValue?.region),
      region_id: regionList,
      set_city_id: Boolean(filterReportRushHourFormValue?.city),
      city_id: cityList,
      start_date: filterReportRushHourFormValue?.start_date,
      end_date: filterReportRushHourFormValue?.end_date,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterReportRushHourFormValue])

  return (
    <div className='d-flex justify-content-end py-3 me-8'>
      <div className='d-flex'>
        <div>
          {state?.brand_id?.map((brand_id, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                Brand :{' '}
                {
                  filterReportRushHourFormValue?.brand?.find((item) => item.value === brand_id)
                    ?.label
                }
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.brand_id
                      ?.slice(0, index)
                      .concat(state?.brand_id.slice(index + 1))
                    state.brand_id = updatedItems
                    state.set_brand_id = (updatedItems ?? []).length > 0
                    setFilterValue({
                      ...filterValue,
                      brand_id: state.brand_id,
                      set_brand_id: state.set_brand_id,
                    })
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.sub_brand_id?.map((sub_brand, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                Sub Brand :{' '}
                {
                  filterReportRushHourFormValue?.sub_brand?.find((item) => item.value === sub_brand)
                    ?.label
                }
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.sub_brand_id
                      ?.slice(0, index)
                      .concat(state?.sub_brand_id.slice(index + 1))
                    state.sub_brand_id = updatedItems
                    state.set_sub_brand_id = (updatedItems ?? []).length > 0
                    setFilterValue({
                      ...filterValue,
                      sub_brand_id: state.sub_brand_id,
                      set_sub_brand_id: state.set_sub_brand_id,
                    })
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.area?.map((area, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                Area :{' '}
                {filterReportRushHourFormValue?.area?.find((item) => item.value === area)?.label}
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.area
                      ?.slice(0, index)
                      .concat(state?.area.slice(index + 1))
                    state.area = updatedItems
                    state.set_area = (updatedItems ?? []).length > 0
                    setFilterValue({
                      ...filterValue,
                      area: state.area,
                      set_area: state.set_area,
                    })
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.region_id?.map((region, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                Region :{' '}
                {
                  filterReportRushHourFormValue?.region?.find((item) => item.value === region)
                    ?.label
                }
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.region_id
                      ?.slice(0, index)
                      .concat(state?.region_id.slice(index + 1))
                    state.region_id = updatedItems
                    state.set_region_id = (updatedItems ?? []).length > 0
                    setFilterValue({
                      ...filterValue,
                      region_id: state.region_id,
                      set_region_id: state.set_region_id,
                    })
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.city_id?.map((city, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                City :{' '}
                {filterReportRushHourFormValue?.city?.find((item) => item.value === city)?.label}
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.city_id
                      ?.slice(0, index)
                      .concat(state?.city_id.slice(index + 1))
                    state.city_id = updatedItems
                    state.set_city_id = (updatedItems ?? []).length > 0
                    setFilterValue({
                      ...filterValue,
                      city_id: state.city_id,
                      set_city_id: state.set_city_id,
                    })
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.outlet_id?.map((outlet, index) => {
            return (
              <span className='badge badge-pill badge-light mx-3 my-2'>
                Outlet :{' '}
                {
                  filterReportRushHourFormValue?.outlet?.find((item) => item.value === outlet)
                    ?.label
                }
                <div
                  className='cursor-pointer'
                  onClick={() => {
                    const updatedItems = state?.outlet_id
                      ?.slice(0, index)
                      .concat(state?.outlet_id.slice(index + 1))
                    state.outlet_id = updatedItems
                    state.set_outlet_id = (updatedItems ?? []).length > 0
                    setFilterValue({
                      ...filterValue,
                      outlet_id: state.outlet_id,
                      set_outlet_id: state.set_outlet_id,
                    })
                    filterData()
                  }}
                >
                  <span className='ki-solid ki-cross fs-2x' />
                </div>
              </span>
            )
          })}
          {state?.start_date && (
            <span className='badge badge-pill badge-light mx-3 my-2 py-4'>
              Date : {moment(state.start_date).format('DD MMMM yyyy')} -{' '}
              {moment(state.end_date).format('DD MMMM yyyy')}
            </span>
          )}
        </div>
        {((state.brand_id! ?? []).length > 0 ||
          (state.sub_brand_id! ?? []).length > 0 ||
          (state.area! ?? []).length > 0 ||
          (state.region_id! ?? []).length > 0 ||
          (state.city_id! ?? []).length > 0 ||
          (state.outlet_id! ?? []).length > 0) && (
          <div
            className='col-auto me-5 d-flex align-items-center h6 text-muted cursor-pointer'
            onClick={() => resetData()}
          >
            <u>Clear All</u>
          </div>
        )}
        <div className='col-auto d-flex align-items-center'>
          <button
            type='button'
            className='btn btn-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            onClick={() => handleShowModal()}
          >
            <KTIcon iconName='filter' className='fs-2' />
            Filter
          </button>
        </div>
      </div>
    </div>
  )
}

export { ReportRushHourListToolbar }

